export default __webpack_public_path__ + "locales/uk-UA/EmptyView.json?hash=2124308f4a0feec91e73c8492d19718d";